import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        tagList: [],
        userInfo: {}
    },
    mutations: {
        setTagList(state, data) {
            state.tagList = data
        },
        setUserInfo(state,userInfo){
            state.userInfo = userInfo
        }
    },
    actions: {},
    modules: {}
})
